import './producer-grid.scss';
import ProducerTabs from './producer-tabs/producer-tabs';

export const ProducerGrid = () => {
  return (
    <>
      <ProducerTabs />
    </>
  );
};
